import { useEffect } from 'react';
import { isFunction } from 'lodash';

export const useButtonClick = (buttonKeyCode: unknown | unknown[], handler: (key) => void) => {
  useEffect(() => {
    const onKeydown = ({ keyCode }) => {
      const codesArr = Array.isArray(buttonKeyCode) ? buttonKeyCode : [buttonKeyCode];
      if (codesArr.includes(keyCode) && isFunction(handler)) handler(keyCode);
    };
    document.addEventListener('keydown', onKeydown, true);
    return () => document.removeEventListener('keydown', onKeydown, true);
  }, [buttonKeyCode, handler]);
};

export default useButtonClick;
